import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PrimaryNavigationMenu from "./sections/PrimaryNavigationMenu";
import EmpoweringEnterpriseEvolution from "./sections/EmpoweringEnterpriseEvolution";
import TheBenefitsOfMobileGrooming from "./sections/TheBenefitsOfMobileGrooming";
import TheCraftRituals from "./sections/TheCraftRituals";
import MeetTheArtisans from "./sections/MeetTheArtisans";
import BrandNewLuxeMobileSpa from "./sections/BrandNewLuxeMobileSpa";
import SiteFooter from "@/reusable_sections/Footer";
import { Link } from "@/components/common/Link";
export default function HomePage() {
  return <div>
      <Header />
      <PrimaryNavigationMenu />
      <EmpoweringEnterpriseEvolution />
      <TheBenefitsOfMobileGrooming />
      <TheCraftRituals />
      <MeetTheArtisans />
      <BrandNewLuxeMobileSpa />
      
      {}
      

      <SiteFooter />
    </div>;
}